export const SOUTH_AMERICA_CODES = [
  "AR",
  "BO",
  "BR",
  "CL",
  "CO",
  "EC",
  "GF",
  "GY",
  "FK",
  "PY",
  "PE",
  "SR",
  "UY",
  "VE",
];
